/**
 * JsonView — read-only, scrollable display of a raw payload (pretty-printed
 * JSON or raw text) with a copy button. Dependency-free; used for the raw bank
 * responses on the artifact detail page.
 */
import CopyToClipboard from '@cloudscape-design/components/copy-to-clipboard';

interface JsonViewProps {
  /** Pre-formatted content: pretty JSON when parseable, else the raw text. */
  value: string;
}

export const JsonView = ({ value }: JsonViewProps) => {
  if (!value) return null;

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', top: 6, right: 6, zIndex: 1 }}>
        <CopyToClipboard
          variant="icon"
          textToCopy={value}
          copyButtonAriaLabel="Copy raw response"
          copySuccessText="Copied"
          copyErrorText="Failed to copy"
        />
      </div>
      <pre
        style={{
          margin: 0,
          padding: '12px 36px 12px 12px',
          maxHeight: 360,
          overflow: 'auto',
          background: '#fbfbfb',
          border: '1px solid #e9ebed',
          borderRadius: 8,
          fontFamily: 'Monaco, Menlo, Consolas, monospace',
          fontSize: 12,
          lineHeight: 1.5,
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        }}
      >
        {value}
      </pre>
    </div>
  );
};
